import { Injectable, inject } from '@angular/core';

import { AdaptiveLayoutFlag, AdaptiveLayoutProvider } from '@frontend/sports/layout/feature';
import { Observable, map } from 'rxjs';

import { SubNavigationItem } from './sub-navigation.models';
import { SubNavigationService } from './sub-navigation.service';

@Injectable({ providedIn: 'root' })
export class SubNavigationLayoutProvider implements AdaptiveLayoutProvider {
    private service = inject(SubNavigationService);

    asObservable(): Observable<AdaptiveLayoutFlag> {
        return this.service.tabs$.pipe(map((value) => this.getState(value)));
    }

    private getState(value: SubNavigationItem[]): AdaptiveLayoutFlag {
        return {
            subNavigation: value && value.length > 0,
        };
    }
}
